export default [["en-us", {
  "empty_list_header": "Welcome to Secure Messaging",
  "empty_list_text": "You don't have any conversations yet",
  "navigation": {
    "conversation_list": "Secure messages {amount, plural, =0 {} other {({amount})}}"
  },
  "unread_message_indicator": "Unread message indicator"
}]];